import { Content } from "antd/es/layout/layout";
import { Outlet } from "@tanstack/react-router";
import { PageHeader } from "components/Navigation/pageHeader/PageHeader";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

export function RootRoute() {
    return (
        <>
            <PageHeader />
            <Content>
                <Outlet />
            </Content>
            <TanStackRouterDevtools initialIsOpen={false} />
            <ReactQueryDevtools initialIsOpen={false} />
        </>
    );
}
